<template>
  <div id="activity" class="maincont">
    <div class="gm-maincont">
      <div class="ef--inner">

        <div class="operation-result" v-if="showUpdate">
          <p>更新しました。</p>
        </div>
        <div class="operation-result" v-if="showDelete">
          <p>削除しました。</p>
        </div>

        <div class="graphlist-header">
          <h2 class="graphlist-header-caption">グラフ編集</h2>
          <ul class="graphlist-header-button">
            <li class="graphlist-header-button-item"><a @click="clickSave(itemGraphList)" class="bt">グラフ名称一括保存</a></li>
            <li class="graphlist-header-button-item"><a @click="cancelMove()" class="bt">キャンセル</a>
            </li>
          </ul>
        </div>

        <div class="graphlist-list-container">
          <table class="normal-table graphlist-table">
            <thead>
              <tr>
                <th class="ma-w-10-p">No.</th>
                <th class="m-w-600-p">グラフ名称</th>
                <th>グラフ編集</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in itemGraphList" v-bind:key="index">
                <td>{{ index + 1 }}</td>
                <td>
                  <input type="text" :name="'graphname_' + index" :value="item.graphName"
                    class="graphlist-table-input-field">
                </td>
                <td>
                  <ul class="graphlist-header-button">
                    <li class="graphlist-list-button-item">
                      <a @click="clickMove2Maintenance(item.graphId)" class="graphlist-bt-cyan">グラフ設定変更</a>
                    </li>
                    <li class="graphlist-list-button-item">
                      <a @click="clickDelete(item.graphId)" class="graphlist-bt-cyan">削除</a>
                    </li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  name: "MultiCiruitGraphBulkChange",

  components: {
  },

  data: function () {
    return {
      itemGraphList: null,
      showUpdate: false,
      showDelete: false,
    };
  },

  watch: {
  },

  computed: {
  },

  mounted: function () {
    if (this.$store.state.beforeAct == "") {
      this.showUpdate = false;
      this.showDelete = false;
      this.$store.dispatch("resetBeforeAct")
    } else if (this.$store.state.beforeAct == 'graph-bulk-change-update') {
      this.showUpdate = true;
      this.$store.dispatch("resetBeforeAct");
    } else if (this.$store.state.beforeAct == 'graph-bulk-change-delete') {
      this.showDelete = true;
      this.$store.dispatch("resetBeforeAct");
    }

    this.getGraphNameBulkChange();
  },

  methods: {
    /* SA1-Ⅲグラフ情報取得API */
    getGraphNameBulkChange: function () {
      this.$axios
        .get(`/srv/api/multi_circuit_graph_name_bulk_change/${this.$store.state.loginID}`, {
          withCredentials: true
        })
        .then(response => {
          this.info = response.data;
          this.itemGraphList = Object.create(response.data.multi_circuit_graphinfo_list);
        })
        .catch(error => {
          console.error(error);
        });
    },

    /* SA1-Ⅲグラフ情報設定API */
    putGraphNameBulkChange: function (params) {
      this.$axios
        .put(`/srv/api/multi_circuit_graph_name_bulk_change/${this.$store.state.loginID}`, params, {
          withCredentials: true
        })
        .then(response => {
          const getdata = response.data;
          if (getdata.status !== undefined) {
            if (getdata.status === "success") {
              this.reload(1);
            } else {
              console.error(response.data.status);
            }
          }

        })
        .catch(error => {
          console.error(error);
        });
    },

    /* SA1-Ⅲグラフ情報削除API */
    postGraphNameBulkChange: function (graphId) {
      const param = { graphId: graphId };

      this.$axios
        .post(`/srv/api/multi_circuit_graph_name_bulk_change/${this.$store.state.loginID}`, param, {
          withCredentials: true
        })
        .then(response => {
          if (response.data.status !== undefined) {
            if (response.data.status === "success") {
              this.$store.dispatch("setBeforeAct", "graph-bulk-change-delete");
              this.reload(2);
            } else {
              console.error(response.data.status);
            }
          }
        })
        .catch(error => {
          console.error(error);
        });
    },

    /* グラフ名称一括保存処理 */
    clickSave: function (itemGraphList) {
      if (!confirm('名称一括保存しますか。')) {
        return;
      }
      if (this.chackGraphName()) {
        return;
      };
      // 更新後、変更なしでボタン押下時、メッセージを消す
      this.showUpdate = false;

      const params = { multi_circuit_graphname_change_list: [] };

      for (let cnt = 0; cnt < itemGraphList.length; cnt++) {
        const newGraphName = document.querySelector(`input[name="graphname_${cnt}"]`).value
        if (newGraphName !== itemGraphList[cnt].graphName) {
          params.multi_circuit_graphname_change_list.push(
            {
              graphId: itemGraphList[cnt].graphId,
              graphName: newGraphName
            }
          );
        }
      }

      // 変更がない場合はAPIリクエストを行わずに画面のみの更新とする
      if (params.multi_circuit_graphname_change_list.length !== 0) {
        this.putGraphNameBulkChange(params)
      } else {
        this.reload(1);
      }
    },

    /* グラフ一覧画面へ戻る処理 */
    cancelMove: function () {
      if (this.chackChangeGraphName()) {
        if (!confirm('変更を保存せずに画面移動しますか？')) {
          return false;
        }
      }
      this.$router.push('multi_circuit_graph_list');
    },

    /* ページ移動処理(グラフメンテナンス画面遷移) */
    clickMove2Maintenance: function (graphId) {
      if (this.chackChangeGraphName()) {
        if (!confirm('変更を保存せずに画面移動しますか？')) {
          return false;
        }
      }
      this.$store.dispatch("setGraphID", graphId);
      this.$router.push('multi_circuit_graph_maintenance');
    },

    /* グラフ削除処理 */
    clickDelete: function (graphId) {
      if (!confirm('削除を実行します。')) {
        return;
      }
      this.postGraphNameBulkChange(graphId)
    },

    /* グラフ名称変更確認 */
    chackChangeGraphName: function () {
      for (let cnt = 0; cnt < this.itemGraphList.length; cnt++) {
        const newGraphName = document.querySelector(`input[name="graphname_${cnt}"]`).value
        if (newGraphName !== this.itemGraphList[cnt].graphName) {
          return true;
        }
      }
      return false;
    },

    /* グラフ名称確認 */
    chackGraphName: function () {
      let newGraphNames = [];
      let graphNames = {};
      let overNames = [];
      let duplicates = [];

      for (let cnt = 0; cnt < this.itemGraphList.length; cnt++) {
        newGraphNames.push({
          graphNumber: cnt + 1,
          graphName: document.querySelector(`input[name="graphname_${cnt}"]`).value
        });
        if (newGraphNames[cnt].graphName.length > 32) {
          overNames.push("No." + newGraphNames[cnt].graphNumber + "  " + newGraphNames[cnt].graphName);
        }
        if (overNames.length === 0) {
          if (graphNames[newGraphNames[cnt].graphName]) {
            for (let index = 0; index < newGraphNames.length; index++) {
              if (newGraphNames[index].graphName === newGraphNames[cnt].graphName) {
                const duplicateMassage = "No." + newGraphNames[index].graphNumber + "  " + newGraphNames[index].graphName
                if (!duplicates.includes(duplicateMassage)) {
                  duplicates.push(duplicateMassage);
                  break
                }
              }
            }
            const duplicateMassage = "No." + newGraphNames[cnt].graphNumber + "  " + newGraphNames[cnt].graphName
            if (!duplicates.includes(duplicateMassage)) {
              duplicates.push(duplicateMassage);
            }
          } else {
            graphNames[newGraphNames[cnt].graphName] = true;
          }
        }
      }

      if (overNames.length > 0) {
        alert("グラフ名称が最大文字数を超えています。（最大32文字）\n" + overNames.join("\n"));
        return true;
      } else if (duplicates.length > 0) {
        alert("グラフ名称が重複しています。\n" + duplicates.join("\n"));
        return true;
      }
      return false;
    },

    /* ページリロード処理 */
    reload(changedFlg) {
      this.$router.go({ path: this.$router.currentRoute.path, force: true });
      if (changedFlg == 1) {
        this.$store.dispatch("setBeforeAct", 'graph-bulk-change-update');
      }
      else if (changedFlg == 2) {
        this.$store.dispatch("setBeforeAct", 'graph-bulk-change-delete');
      }
      else {
        this.$store.dispatch("resetBeforeAct");
      }
    },
  },
};
</script>
<style scoped>
/* グラフ一覧のボタンの配置 */
.graphlist-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  width: auto;
  background-color: #5ca1d6;
  border-radius: 8px 8px 0 0;
  min-height: 45px;
  padding: 0 15px 5px;
}

.graphlist-header-caption {
  color: #FFFFFF;
  font-size: 18px;
  line-height: 45px;
}

/* グラフ一覧のボタンの見た目 */
.graphlist-header-button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

/* グラフのボタンの幅 */
.graphlist-header-button-item {
  margin: 0 auto;
  margin-left: 10px;
}

/* グラフ一覧のボタンの背景、文字色 */
.graphlist-header-button .bt {
  display: inline-block;
  background-color: #fff;
  border-radius: 20px;
  padding: 4px 14px;
  color: #444;
  font-size: 14px;
}

/* グラフ一覧のボタンをマウスオーバーしたときの色 */
.graphlist-header-button .bt:hover {
  opacity: .8;
}

.operation-result {
  border-radius: 8px 8px 8px 8px;
  min-height: 30px;
  padding: 15px 15px 5px;
  background-color: #99ff99;
  font-size: 16px;
  margin: 3px 0px 20px 0px;
}

/* 表テーブルの枠 */
.graphlist-list-container {
  overflow: auto;
  display: flex;
  width: auto;
  max-height: 500px;
  margin-bottom: 20px;
}

/* 表の列の幅 */
.m-w-600-p {
  min-width: 600px !important;
}

.m-w-30-p {
  min-width: 30px !important;
}

.ma-w-10-p {
  max-width: 10px !important;
}

.graphlist-table {
  width: 1202px;
}

.graphlist-table-input-field {
  background-color: #fff;
  border: 1px solid #5CA1D6;
  border-radius: 2px;
  display: inline-block;
  width: 90%;
  box-sizing: border-box;
  padding: 5px;
  margin: 3px 0px 3px 0px;
  font-size: 14px;
  font-weight: normal;
}

/* グラフ名称のテキストボックスの色、形 */
.graphlist-table-input-field {
  background-color: #fff;
  border: 1px solid #5CA1D6;
  border-radius: 2px;
  display: inline-block;
  width: 90%;
  box-sizing: border-box;
  margin: 5px 0px 5px 0px;
  font-size: 16px;
  font-weight: normal;
}

/* グラフ編集のボタンの形、文字色 */
.graphlist-bt-cyan {
  display: block;
  background-color: #5ca1d6;
  border: none;
  border-radius: 4px;
  width: 90px;
  padding: 5px 10px;
  color: #fff;
  font-size: 12px;
  font-weight: normal;
  line-height: 18px;
  text-align: center;
}

/* グラフ編集のボタンの配置 */
.graphlist-list-button-item {
  margin: 0 auto;
}

.graphlist-bt-cyan:hover {
  background-color: #005cc0;
}
</style>